import { openModal } from '@core/components/ModalStack';
import { SetDealTerritoryModalProps } from './SetDealTerritoryModal';

export async function openSetDealTerritoryModal(props: SetDealTerritoryModalProps) {
  const { SetDealTerritoryModal } = await import('./SetDealTerritoryModal');

  openModal(SetDealTerritoryModal, props);
}
